import script from "./insurance.vue?vue&type=script&setup=true&lang=js"
export * from "./insurance.vue?vue&type=script&setup=true&lang=js"

import "./insurance.vue?vue&type=style&index=0&id=051d9d02&scoped=true&lang=less"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-051d9d02"]])

export default __exports__